import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter, useHistory, Redirect } from 'react-router-dom'
import { rolesActions } from '../../../actions/rolesActions'
import { usersActions } from '../../../actions/usersActions'
import { businessunitsActions } from '../../../actions/businessunitsActions'
import { authApi } from '../../../api/authApi'
import { routes } from '../../../constantes/routes'
import PlusBtn from '../../buttons/PlusBtn'
import UsersList from '../users/UsersList'
import UserModal from './UserModal'
import {
  swalAlertIsConfirm,
  swalAlertError,
  swalSuccessGeneral,
} from '../../../utils/swalAlert'
import { swalTitle } from '../../../constantes/swalTitle'
import Search from '../../common/Search'
import Header from '../../header/Header'
import { swalMssgs } from '../../../constantes/swalMssgs'
import { userTypes } from '../../../constantes/actionTypes'
import { onSubmitText } from '../../../constantes/onSubmitText'
import validators from '../../../utils/validationsRegEx'
import { downloadCSV } from '../../../utils/downloadCSV'
import { exportActions } from '../../../actions/exportActions'
import { entitiesExport } from '../../../constantes/exportEndpoints'
import { hospitalsActions } from '../../../actions/hospitalsActions'

const Users = () => {
  const history = useHistory()

  const allUsers = useSelector((state) => state.users)
  const userProfile = useSelector((state) => state.userProfile)
  const rolesList = useSelector((state) => state.rolesList)
  // const zones = useSelector((state) => state.zones)
  const communities = useSelector((state) => state.communities)
  const colors = useSelector((state) => state.colors)
  const businessunits = useSelector((state) => state.businessunits)

  const [items, setItems] = useState(allUsers)

  // Estados para el modal
  const [userModalIsOpen, setUserModalIsOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [userToEdit, setUserToEdit] = useState(null)
  const [newUser, setNewUser] = useState({
    nombre: '',
    email: '',
    telefono: '',
    id_Rol: '',
    id_TipoZona: '',
    id_TipoColor: '1',
    businessUnits: [],
  })

  const dispatch = useDispatch()
  const getAllUsers = () => dispatch(usersActions.getAllUsers())
  const getAllRoles = () => dispatch(rolesActions.getRoles())
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllComunities = () => dispatch(hospitalsActions.getAllCommunities())

  const logout = () => dispatch(authApi.logout())
  const deleteUser = (idUser) => dispatch(usersActions.deleteUserById(idUser))
  const createUser = (user) => dispatch(usersActions.newUser(user))
  const updateUser = (user) => dispatch(usersActions.updateUser(user))

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllUsers()
      getAllRoles()
      getAllBusinessUnits()
      getAllComunities()
    }
  }, [])

  useEffect(() => {
    setItems(allUsers)
  }, [allUsers])

  // Efecto simplificado: ya no necesitamos este useEffect complejo
  // porque ahora usamos directamente negocioUnidadesObj en toEditUser

  const handleRemove = async (idUser) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar el usuario?',
      )
      if (userProfile.id_Usuario === idUser) {
        await logout()
        history.push(routes.LANDING)
        return
      }
      if (alert.isConfirmed) {
        const response = await deleteUser(idUser) //usersApi.deleteUser(idUser)
        if (userTypes.DELETE_USER_SUCCESS === response.type) {
          swalSuccessGeneral(swalTitle.Eliminado, swalMssgs.DELETE_SUCCESS)
        }
      }
    } catch (error) {
      swalAlertError(error.payload)
    }
  }

  const toNewUser = () => {
    setNewUser({
      nombre: '',
      email: '',
      telefono: '',
      id_Rol: '',
      id_TipoZona: '',
      id_TipoColor: '1',
      businessUnits: [],
      negocioUnidadesObj: [], // Sincronizar desde el inicio
    })
    setIsEditMode(false)
    setUserToEdit(null)
    setUserModalIsOpen(true)
  }

  const toEditUser = (id) => {
    const user = allUsers.find((u) => u.id_Usuario.toString() === id.toString())
    if (user) {
      // Simplificar: usar directamente negocioUnidadesObj como fuente de verdad
      const userBusinessUnits = user.negocioUnidadesObj || []

      setNewUser({
        ...user,
        businessUnits: userBusinessUnits,
        negocioUnidadesObj: userBusinessUnits, // Sincronizar desde el inicio
      })
      setIsEditMode(true)
      setUserToEdit(user)
      setUserModalIsOpen(true)
    }
  }

  const closeUserModal = () => {
    setUserModalIsOpen(false)
    setIsEditMode(false)
    setUserToEdit(null)
    setNewUser({
      nombre: '',
      email: '',
      telefono: '',
      id_Rol: '',
      id_TipoZona: '',
      id_TipoColor: '1',
      businessUnits: [],
      negocioUnidadesObj: [], // Sincronizar desde el inicio
    })
  }

  const handleChangeNewUser = (event) => {
    const value = event.target.value
    const name = event.target.name

    // Si estamos cambiando businessUnits, también actualizar negocioUnidadesObj
    if (name === 'businessUnits') {
      setNewUser({
        ...newUser,
        [name]: value,
        negocioUnidadesObj: value, // Sincronizar ambos campos
      })
    } else {
      setNewUser({ ...newUser, [name]: value })
    }
  }

  const handleSubmitUser = async (event) => {
    event.preventDefault()
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...userData } = newUser
      const userDataWithBusinessUnits = {
        ...userData,
        id_NegocioUnidades: businessUnits
          ? businessUnits.map((bu) => bu.id_NegocioUnidad)
          : [],
      }

      if (isEditMode) {
        const response = await updateUser(userDataWithBusinessUnits)
        if (userTypes.UPDATE_USER_SUCCESS === response.type) {
          swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
          closeUserModal()
          getAllUsers()
        } else {
          swalAlertError('Error al actualizar el usuario')
        }
      } else {
        const response = await createUser(userDataWithBusinessUnits)
        if (userTypes.NEW_USER_SUCCESS === response.type) {
          swalSuccessGeneral(
            swalTitle.CreadoCorrectamente,
            swalMssgs.NEW_SUCCES,
          )
          closeUserModal()
          getAllUsers()
        } else {
          swalAlertError('Error al crear el usuario')
        }
      }
    } catch (error) {
      const errorMessage =
        error.payload ||
        (isEditMode
          ? 'Error al actualizar el usuario'
          : 'Error al crear el usuario')
      swalAlertError(errorMessage)
    }
  }

  const validateUserForm = () => {
    return (
      validators.emailFormat(newUser.email) &&
      (!validators.hasValue(newUser.telefono) ||
        validators.phoneNumberFormat(newUser.telefono)) &&
      validators.hasValue(newUser.id_Rol) &&
      validators.hasValue(newUser.nombre)
      // Eliminado: requirement de businessUnits - ahora puede estar vacío
    )
  }

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const onChangeSearch = (value) => {
    const newItems = allUsers.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  const handleExportCSV = async () => {
    const response = await dispatch(
      exportActions.exportCSV(entitiesExport.USERS),
    )
    downloadCSV('Usuarios', response)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Usuarios Internos'}
            route={toBackoffice}
            backBtn={true}
          />
          <div className='filter__wrap mb-80'>
            <Search
              onChangeSearch={onChangeSearch}
              placeholder='Buscar por nombre...'
            />
            <div className='add__action__rigth__side'>
              <button
                onClick={handleExportCSV}
                className='btn-landing'
                style={{ cursor: 'pointer', marginRight: '10px' }}
              >
                📊 Exportar CSV
              </button>
              <button className='action-button' onClick={toNewUser}>
                <PlusBtn />
                <span>Nuevo usuario</span>
              </button>
            </div>
          </div>
          <UsersList
            allUsers={items}
            handleRemove={handleRemove}
            toEditUser={toEditUser}
            userProfile={userProfile}
          />

          {/* Modal para crear/editar usuario */}
          <UserModal
            modalIsOpen={userModalIsOpen}
            closeModal={closeUserModal}
            inputs={newUser}
            handleChange={handleChangeNewUser}
            handleSubmit={handleSubmitUser}
            validateForm={validateUserForm}
            textBtn={isEditMode ? onSubmitText.Guardar : onSubmitText.Crear}
            communities={communities}
            businessunits={businessunits}
            colors={colors}
            rolesList={rolesList}
            isEdit={isEditMode}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}
export default withRouter(Users)
